import axios from 'axios';

// Same-origin API calls work on ANY domain the site is served from
// (dryicebulls.com, emergent.host, preview URL, etc.). Only fall back to
// the env-configured URL if provided (used during local dev when the
// backend and frontend run on different origins).
const BACKEND_URL = (typeof window !== 'undefined' && window.location.origin)
    ? (process.env.REACT_APP_BACKEND_URL_OVERRIDE || window.location.origin)
    : (process.env.REACT_APP_BACKEND_URL || '');
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

// Convert a relative /api/uploads/... path to a full URL for <img src>.
export const assetUrl = (path) => {
    if (!path) return '';
    if (/^https?:\/\//i.test(path)) return path;
    if (path.startsWith('/api/')) return `${BACKEND_URL}${path}`;
    return path;
};

// Attach admin token from localStorage on every request (fallback to cookie)
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('dib_admin_token');
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export const formatPrice = (p) => {
    if (p == null) return 'Contact for Pricing';
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(p);
};

export const TIMEPAYMENT_URL = 'https://secure.financ.ing/app?dealercode=VZFJY&apptype=B&qs=apply';
